export class LojistikFiyatArsiv {
    id: number;
    tarih: Date;
    fiyat: number;
    
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    
    Object.assign(this, obj);
  }
}
